module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HhGaSr/images/9780991545438_cover.jpg?1684514755581",
      "alt": "This image is the cover for the book Soft Volcano"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Soft Volcano\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At the core of Libby Burton's highly anticipated debut poetry collection, Soft Volcano, are the vivid details underpinning the relationships we hold dearly in our lives. A feminist force, highly wrought and impressionistic, surges from these intensely lyric distillations that show us what we look like standing in the hallways of the museum of lost love—where we stand, how our hair looks, what marks of woe and time are left upon the body after love is strained or abandoned. Soft Volcano is a book of vivid and crushing lyric poems, each one a swell of danger, beauty, and truth.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Libby Burton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("LIBBY BURTON is a senior editor at Henry Holt. She earned a BA with high honors, as part of the Area Program in Poetry Writing, from the University of Virginia, and an MFA from Columbia University. Her poetry has appeared in Atlas Review, Denver Quarterly, Guernica, Juked, la fovea, Meridian, North American Poetry Review, Painted Bride Quarterly, Western Humanities Review, and Tin House, among others. She lives in Brooklyn.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Saturnalia Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0